import React from 'react';
import { motion } from 'framer-motion';
import { FaHandshake } from 'react-icons/fa';

// Import partner logos
import partner1 from '../../assets/partners/9.webp';
import partner2 from '../../assets/partners/commonvalut-(1).png';
import partner3 from '../../assets/partners/knowlarity-2.webp';
import partner4 from '../../assets/partners/gcp-partner-(2).webp';
import partner5 from '../../assets/partners/crowdstrike.png';
import partner6 from '../../assets/partners/AWS_logo_RGB.png';
import partner7 from '../../assets/partners/microsoft.png';

const PartnersSection = () => {
  const partners = [
    { name: "Partner 1", logo: partner1 },
    { name: "CommonVault", logo: partner2 },
    { name: "Knowlarity", logo: partner3 },
    { name: "GCP Partner", logo: partner4 },
    { name: "CrowdStrike", logo: partner5 },
    { name: "AWS", logo: partner6 },
    { name: "Microsoft", logo: partner7 },
    // Duplicate for smooth infinite scroll
    { name: "Partner 1", logo: partner1 },
    { name: "CommonVault", logo: partner2 },
    { name: "Knowlarity", logo: partner3 },
    { name: "GCP Partner", logo: partner4 },
    { name: "CrowdStrike", logo: partner5 },
    { name: "AWS", logo: partner6 },
    { name: "Microsoft", logo: partner7 },
  ];

  return (
    <section className="py-16 bg-white relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-2xl mb-6">
            <FaHandshake className="text-2xl text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our{' '}
            <span className="bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
              Trusted Partners
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We collaborate with industry-leading partners to deliver exceptional cloud solutions
          </p>
        </motion.div>
        
        {/* Partners Section */}
        <motion.div 
          className="mb-8"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          {/* Scrollable Partners Container */}
          <div className="relative overflow-hidden bg-gradient-to-r from-gray-50 to-blue-50 rounded-2xl shadow-lg border border-gray-100 py-8">
            <div className="flex animate-scroll">
              {partners.map((partner, index) => (
                <div 
                  key={index}
                  className="flex-shrink-0 mx-8 flex items-center justify-center h-20 w-32"
                >
                  <img 
                    src={partner.logo} 
                    alt={partner.name}
                    className="max-h-16 max-w-full object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PartnersSection;